<template>
<div class="wrapper" style="height:400px;width:100%;">
  <div class="form-inline">
      <button @click="save()" class="btn btn-secondary mr-3"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
      <select @change="updateScript" v-model="scriptId" class="form-control ml-3">
        <option value="">-</option>
        <option value="sync.modulator.article">Artikel</option>
        <option value="sync.modulator.artdesc">Artikeltext</option>
        <option value="sync.modulator.price">Preise</option>
        <option value="sync.modulator.customer">Kunden</option>
        <option value="sync.modulator.shop_address">Adressen</option>
        <option value="sync.modulator.categories">Kategorien</option>
        <option value="sync.modulator.order">Auftragsdaten</option>
      </select>
  </div>
  <div class="row mt-2">
    <div class="col-md">
      <AceEditor ref="editor" :editorId='"datamoduledit"' :lang="'javascript'" :content="script"/>
    </div>
    <div class="col-md">
      <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/scriptrules/ihand_datamodulator.html'">
      </iframe>
    </div>
  </div>
</div>
</template>

<script>
import config from '@/modules/config.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'RuleDataModulator',
  components: {
    AceEditor
  },
  data() {
    return {
      baseurl: config.baseUrl,
      script: "",
      scriptId: "",
    }
  },
  created: function() {
  },
  methods: {
    updateScript: function() {
      if (this.scriptId == '') return;
      var self = this;
      config.get(this,config.baseUrl + 'rest/config/base?prefix=' + this.scriptId,'Daten Regel laden',function(data) {
        if (data) {
          self.script = data[self.scriptId];
        }
      });
    },
    save: function() {
      if (this.scriptId == '') return;
      this.script = this.$refs.editor.getContent();
      var data = {};
      data[this.scriptId] = this.script;

      var self = this;
      config.savecfg(data,this,function() {
        console.log('done');
        self.$bvToast.toast('Daten Regel gesichert.',{title: 'Gespeichert', variant: "success"});
      })
    }
  }
}
</script>
